<span class="cursor-help" *ngIf="location" [ngbTooltip]="tooltip" placement="right" container="body">
    <sb-icon class="mr-1" icon="{{faIcon}}" [ngClass]="color"></sb-icon>
    <span [ngClass]="color">{{text}}</span>
</span>
